import { IconType } from '@kinomap-dev/ng-ui-lib/core';
import { ContentType } from '../../pages/content-creation/content-creation';

export type PreviewChipData =
  'duration' | 'distance' | 'positiveSlope' | 'workoutMode' | 'calories';

export const PREVIEW_CHIP_ICONS: Readonly<Record<PreviewChipData, IconType>> = {
  duration: 'timer',
  distance: 'double_arrow',
  positiveSlope: 'slope',
  workoutMode: 'force',
  calories: 'calories',
};

export const DEFAULT_PREVIEW_CHIPS: readonly PreviewChipData[] = [
  'duration',
  'distance',
  'positiveSlope',
];

export const PREVIEW_CHIPS_BY_CONTENT_TYPE: Readonly<
  Partial<Record<ContentType, readonly PreviewChipData[]>>
> = {
  'gps-only': ['distance', 'positiveSlope'],
  workout: ['duration', 'workoutMode'],
  coaching: ['duration', 'calories'],
};
